// selectors
import { MOMENT_FORMAT, COLON } from 'app/common/constants'

import moment from 'moment'
import momentDurationFormatSetup from 'moment-duration-format'
momentDurationFormatSetup(moment)

export default {
	
}